import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getEquipmentModals } from "./equipmentAPI";

const initialState = []

export const fetchEquipmentModals = createAsyncThunk(
    'ui/fetchEquipmentModals',
    async (obj, thunkAPI) => {
      const { getState } = thunkAPI;
      const response = await getEquipmentModals(obj);
      return response.data;
    }
);

const equipmentModalsSlice = createSlice({
    name: 'modals',
    initialState,
    reducers: {
      setInverterData: (state, action) => {
     
        //state.inverter = action.payload?.inverter;
      }
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchEquipmentModals.pending, (state) => {
            return {
              ...state,
              status: "loading",
              modalDataLoaded: false,
              modalDataFetchFailed: false,
              modalData: initialState
            }
          })
          .addCase(fetchEquipmentModals.fulfilled, (state, action) => {
            return {
              ...state,
              status: "idle",
              modalData: action.payload,
              modalDataFetchFailed: false,
              modalDataLoaded: true
            }
          })
          .addCase(fetchEquipmentModals.rejected, (state) => {
            return {
              ...state,
              modalFetchFailed: true,
              status: "idle",
              modalDataLoaded: true,
            }
          })
        },
});


export const getModalByMfrs = (state) => state.modals?.modalData;

export default equipmentModalsSlice.reducer;
